import { Icon } from "@chakra-ui/react";

// Dashboard Icon
export const DashboardIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.24072 8.05245C3.66109 8.33333 4.24628 8.33333 5.41667 8.33333C6.58706 8.33333 7.17225 8.33333 7.59262 8.05245C7.77461 7.93085 7.93086 7.7746 8.05245 7.59262C8.33333 7.17224 8.33333 6.58705 8.33333 5.41667C8.33333 4.24628 8.33333 3.66109 8.05245 3.24072C7.93086 3.05873 7.77461 2.90248 7.59262 2.78088C7.17225 2.5 6.58706 2.5 5.41667 2.5C4.24628 2.5 3.66109 2.5 3.24072 2.78088C3.05873 2.90248 2.90248 3.05873 2.78089 3.24072C2.5 3.66109 2.5 4.24628 2.5 5.41667C2.5 6.58705 2.5 7.17224 2.78089 7.59262C2.90248 7.7746 3.05873 7.93085 3.24072 8.05245Z"
      stroke={props.color || "white"}
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M12.4086 8.05245C12.8291 8.33333 13.4142 8.33333 14.5846 8.33333C15.755 8.33333 16.3402 8.33333 16.7606 8.05245C16.9426 7.93085 17.0988 7.7746 17.2204 7.59262C17.5013 7.17224 17.5013 6.58705 17.5013 5.41667C17.5013 4.24628 17.5013 3.66109 17.2204 3.24072C17.0988 3.05873 16.9426 2.90248 16.7606 2.78088C16.3402 2.5 15.755 2.5 14.5846 2.5C13.4142 2.5 12.8291 2.5 12.4086 2.78088C12.2267 2.90248 12.0705 3.05873 11.9488 3.24072C11.668 3.66109 11.668 4.24628 11.668 5.41667C11.668 6.58705 11.668 7.17224 11.9488 7.59262C12.0705 7.7746 12.2267 7.93085 12.4086 8.05245Z"
      stroke={props.color || "white"}
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M3.24072 17.2194C3.66109 17.5003 4.24628 17.5003 5.41667 17.5003C6.58706 17.5003 7.17225 17.5003 7.59262 17.2194C7.77461 17.0978 7.93086 16.9416 8.05245 16.7596C8.33333 16.3392 8.33333 15.7541 8.33333 14.5837C8.33333 13.4132 8.33333 12.8281 8.05245 12.4077C7.93086 12.2257 7.77461 12.0695 7.59262 11.9479C7.17225 11.667 6.58706 11.667 5.41667 11.667C4.24628 11.667 3.66109 11.667 3.24072 11.9479C3.05873 12.0695 2.90248 12.2257 2.78089 12.4077C2.5 12.8281 2.5 13.4132 2.5 14.5837C2.5 15.7541 2.5 16.3392 2.78089 16.7596C2.90248 16.9416 3.05873 17.0978 3.24072 17.2194Z"
      stroke={props.color || "white"}
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M12.4086 17.2194C12.8291 17.5003 13.4142 17.5003 14.5846 17.5003C15.755 17.5003 16.3402 17.5003 16.7606 17.2194C16.9426 17.0978 17.0988 16.9416 17.2204 16.7596C17.5013 16.3392 17.5013 15.7541 17.5013 14.5837C17.5013 13.4132 17.5013 12.8281 17.2204 12.4077C17.0988 12.2257 16.9426 12.0695 16.7606 11.9479C16.3402 11.667 15.755 11.667 14.5846 11.667C13.4142 11.667 12.8291 11.667 12.4086 11.9479C12.2267 12.0695 12.0705 12.2257 11.9488 12.4077C11.668 12.8281 11.668 13.4132 11.668 14.5837C11.668 15.7541 11.668 16.3392 11.9488 16.7596C12.0705 16.9416 12.2267 17.0978 12.4086 17.2194Z"
      stroke={props.color || "white"}
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
  </svg>
);

// Mall/Building Icon
export const MallIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66797 18.3335H18.3346"
      stroke={props.color || "white"}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33203 18.3332V5.62585C3.33203 5.10563 3.33203 4.84553 3.47205 4.63651C3.61206 4.42748 3.86421 4.31116 4.36851 4.07851L8.11851 2.34853C9.3347 1.78748 9.94278 1.50695 10.3874 1.76049C10.832 2.01403 10.832 2.64131 10.832 3.89588V18.3332"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6654 18.3335V9.36358C16.6654 8.86241 16.6654 8.61183 16.5202 8.41041C16.3749 8.20904 16.1134 8.09697 15.5905 7.87284L10.832 5.8335"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 7.5H7.91667M6.25 10.8333H7.91667M6.25 14.1667H7.91667"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Restaurant Icon
export const RestaurantIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 10V14.1667M2.5 14.1667H4.16667C5.34517 14.1667 5.93443 14.1667 6.30055 14.5328C6.66667 14.8989 6.66667 15.4882 6.66667 16.6667V17.5M2.5 14.1667V17.5"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33203 5.83333L7.76263 3.40287C8.85986 2.80096 9.40853 2.5 9.9987 2.5C10.5889 2.5 11.1375 2.80096 12.2348 3.40287L16.6654 5.83333"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 5V8.33333M5 5V8.33333"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4987 10V14.1667M17.4987 14.1667H15.832C14.6535 14.1667 14.0643 14.1667 13.6981 14.5328C13.332 14.8989 13.332 15.4882 13.332 16.6667V17.5M17.4987 14.1667V17.5"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83203 11.667H9.9987M9.9987 11.667H14.1654M9.9987 11.667V17.5003M9.9987 17.5003H9.16536M9.9987 17.5003H10.832"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Users Icon
export const UsersIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8346 9.16634C10.8346 7.32539 9.34222 5.83301 7.5013 5.83301C5.66035 5.83301 4.16797 7.32539 4.16797 9.16634C4.16797 11.0073 5.66035 12.4997 7.5013 12.4997C9.34222 12.4997 10.8346 11.0073 10.8346 9.16634Z"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.20014 6.29811C9.17889 6.14623 9.16797 5.99106 9.16797 5.83333C9.16797 3.99238 10.6604 2.5 12.5013 2.5C14.3422 2.5 15.8346 3.99238 15.8346 5.83333C15.8346 7.67428 14.3422 9.16667 12.5013 9.16667C11.8808 9.16667 11.3 8.99717 10.8025 8.70192"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 17.5C12.5 14.7386 10.2614 12.5 7.5 12.5C4.73857 12.5 2.5 14.7386 2.5 17.5"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 14.167C17.5 11.4056 15.2614 9.16699 12.5 9.16699"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Promo/Discount Icon
export const PromoIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4386 2.42618L6.8946 5.08742C6.46793 5.29223 6.01203 5.34355 5.54729 5.23943C5.24314 5.1713 5.09105 5.13723 4.96858 5.12325C3.44786 4.94959 2.5 6.15317 2.5 7.53722V8.29677C2.5 9.68082 3.44786 10.8844 4.96858 10.7107C5.09105 10.6967 5.24315 10.6627 5.54729 10.5946C6.01203 10.4904 6.46793 10.5417 6.8946 10.7466L12.4386 13.4078C13.7112 14.0187 14.3475 14.3242 15.057 14.0861C15.7664 13.848 16.0099 13.3371 16.497 12.3153C17.8343 9.50966 17.8343 6.32437 16.497 3.51862C16.0099 2.49687 15.7664 1.986 15.057 1.74791C14.3475 1.50982 13.7112 1.81527 12.4386 2.42618Z"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.54712 17.3088L8.30432 18.333C5.50299 16.1113 5.84523 15.0518 5.84523 10.833H6.79009C7.17352 13.2171 8.07797 14.3463 9.32595 15.1638C10.0947 15.6673 10.2532 16.7268 9.54712 17.3088Z"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 10.417V5.41699"
      stroke={props.color || "white"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Settings Icon
export const SettingsIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9154 9.99967C12.9154 11.6105 11.6095 12.9163 9.9987 12.9163C8.38786 12.9163 7.08203 11.6105 7.08203 9.99967C7.08203 8.38884 8.38786 7.08301 9.9987 7.08301C11.6095 7.08301 12.9154 8.38884 12.9154 9.99967Z"
      stroke={props.color || "white"}
      strokeWidth="1.5"
    />
    <path
      d="M17.3268 7.62667C17.9987 8.78483 18.3346 9.36383 18.3346 10C18.3346 10.6362 17.9987 11.2152 17.3268 12.3733L15.7237 15.1365C15.0545 16.29 14.7199 16.8668 14.1696 17.1834C13.6193 17.5 12.9515 17.5 11.6157 17.5H8.38689C7.05115 17.5 6.3833 17.5 5.83303 17.1834C5.28275 16.8668 4.94813 16.29 4.27889 15.1365L2.67582 12.3733C2.00392 11.2152 1.66797 10.6362 1.66797 10C1.66797 9.36383 2.00392 8.78483 2.67582 7.62667L4.27889 4.86351C4.94813 3.70997 5.28275 3.1332 5.83303 2.8166C6.3833 2.5 7.05115 2.5 8.38689 2.5H11.6157C12.9515 2.5 13.6193 2.5 14.1696 2.8166C14.7199 3.1332 15.0545 3.70997 15.7237 4.86352L17.3268 7.62667Z"
      stroke={props.color || "white"}
      strokeWidth="1.5"
    />
  </svg>
);

// Search Icon
export const SearchIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
      />
    </svg>
  </Icon>
);

// Notification/Bell Icon
export const NotificationIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9154 15C12.9154 16.6108 11.6095 17.9167 9.9987 17.9167C8.38786 17.9167 7.08203 16.6108 7.08203 15"
      stroke="#929292"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0259 15.0002H3.97406C3.15996 15.0002 2.5 14.3402 2.5 13.5261C2.5 13.1352 2.6553 12.7602 2.93174 12.4837L3.43443 11.9811C3.90327 11.5122 4.16667 10.8763 4.16667 10.2133V7.91683C4.16667 4.69517 6.77834 2.0835 10 2.0835C13.2217 2.0835 15.8333 4.69516 15.8333 7.91683V10.2133C15.8333 10.8763 16.0967 11.5122 16.5656 11.9811L17.0682 12.4837C17.3447 12.7602 17.5 13.1352 17.5 13.5261C17.5 14.3402 16.84 15.0002 16.0259 15.0002Z"
      stroke="#929292"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Logout Icon
export const LogoutIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
      />
    </svg>
  </Icon>
);

// Chevron Down Icon
export const ChevronDownIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
      />
    </svg>
  </Icon>
);

// Chevron Right Icon
export const ChevronRightIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
      />
    </svg>
  </Icon>
);

// Chevron Left Icon
export const ChevronLeftIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
      />
    </svg>
  </Icon>
);

// Plus/Add Icon
export const PlusIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
    </svg>
  </Icon>
);

// Edit Icon
export const EditIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.80964 16.5237L16.5237 6.80964C16.9781 6.35527 17.2052 6.12808 17.3267 5.883C17.5578 5.41671 17.5578 4.86925 17.3267 4.40295C17.2052 4.15787 16.9781 3.93068 16.5237 3.47631C16.0693 3.02193 15.8421 2.79475 15.5971 2.6733C15.1307 2.44223 14.5833 2.44223 14.117 2.6733C13.8719 2.79475 13.6447 3.02193 13.1904 3.47631L3.47631 13.1903C2.99459 13.672 2.75373 13.9129 2.62687 14.2192C2.5 14.5254 2.5 14.8661 2.5 15.5473V17.4999H4.45262C5.13388 17.4999 5.4745 17.4999 5.78078 17.3731C6.08707 17.2463 6.32793 17.0053 6.80964 16.5237Z"
      stroke="#121212"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 17.5H15"
      stroke="#121212"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.082 4.5835L15.4154 7.91683"
      stroke="#121212"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SidebarIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66797 10C1.66797 6.87522 1.66797 5.31283 2.46373 4.21756C2.72073 3.86383 3.0318 3.55276 3.38553 3.29576C4.4808 2.5 6.04319 2.5 9.16797 2.5H10.8346C13.9594 2.5 15.5218 2.5 16.6171 3.29576C16.9708 3.55276 17.2819 3.86383 17.5389 4.21756C18.3346 5.31283 18.3346 6.87522 18.3346 10C18.3346 13.1247 18.3346 14.6872 17.5389 15.7824C17.2819 16.1362 16.9708 16.4472 16.6171 16.7042C15.5218 17.5 13.9594 17.5 10.8346 17.5H9.16797C6.04319 17.5 4.4808 17.5 3.38553 16.7042C3.0318 16.4472 2.72073 16.1362 2.46373 15.7824C1.66797 14.6872 1.66797 13.1247 1.66797 10Z"
      stroke="#929292"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M7.91797 2.9165V17.0832"
      stroke="#929292"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M4.16797 5.8335C4.16797 5.8335 4.92981 5.8335 5.41797 5.8335"
      stroke="#929292"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16797 9.1665H5.41797"
      stroke="#929292"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1667 8.3335L13.1446 9.2145C12.7148 9.58483 12.5 9.77008 12.5 10.0002C12.5 10.2302 12.7148 10.4155 13.1446 10.7858L14.1667 11.6668"
      stroke="#929292"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Delete/Trash Icon
export const DeleteIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.25 4.5835L15.7336 12.9377C15.6016 15.0722 15.5357 16.1394 15.0007 16.9067C14.7361 17.2861 14.3956 17.6062 14.0006 17.8468C13.2017 18.3335 12.1325 18.3335 9.99392 18.3335C7.8526 18.3335 6.78192 18.3335 5.98254 17.8459C5.58733 17.6049 5.24667 17.2842 4.98223 16.9042C4.4474 16.1357 4.38288 15.0669 4.25384 12.9295L3.75 4.5835"
      stroke="#FF5655"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M2.5 4.58317H17.5M13.3798 4.58317L12.8109 3.40961C12.433 2.63005 12.244 2.24027 11.9181 1.99718C11.8458 1.94325 11.7693 1.89529 11.6892 1.85375C11.3283 1.6665 10.8951 1.6665 10.0288 1.6665C9.14067 1.6665 8.69667 1.6665 8.32973 1.8616C8.24842 1.90485 8.17082 1.95475 8.09774 2.01081C7.76803 2.26375 7.58386 2.6678 7.21551 3.47589L6.71077 4.58317"
      stroke="#FF5655"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M7.91797 13.75V8.75"
      stroke="#FF5655"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M12.082 13.75V8.75"
      stroke="#FF5655"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
);

export const BlockIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.375 4.16699L16.0417 15.8337"
      stroke="#FF5655"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5417 10.0003C18.5417 5.39795 14.8107 1.66699 10.2083 1.66699C5.60596 1.66699 1.875 5.39795 1.875 10.0003C1.875 14.6027 5.60596 18.3337 10.2083 18.3337C14.8107 18.3337 18.5417 14.6027 18.5417 10.0003Z"
      stroke="#FF5655"
      strokeWidth="1.5"
    />
  </svg>
);

// View/Eye Icon
export const ViewIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9546 9.204C18.208 9.55925 18.3346 9.73692 18.3346 9.99984C18.3346 10.2628 18.208 10.4404 17.9546 10.7957C16.8162 12.392 13.909 15.8332 10.0013 15.8332C6.09362 15.8332 3.18639 12.392 2.048 10.7957C1.79464 10.4404 1.66797 10.2628 1.66797 9.99984C1.66797 9.73692 1.79464 9.55925 2.048 9.204C3.18639 7.6077 6.09362 4.1665 10.0013 4.1665C13.909 4.1665 16.8162 7.6077 17.9546 9.204Z"
      stroke="#148FFF"
      strokeWidth="1.25"
    />
    <path
      d="M12.5 10C12.5 8.61925 11.3807 7.5 10 7.5C8.61925 7.5 7.5 8.61925 7.5 10C7.5 11.3807 8.61925 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10Z"
      stroke="#148FFF"
      strokeWidth="1.25"
    />
  </svg>
);

// Close Icon
export const CloseIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      />
    </svg>
  </Icon>
);

// Check Icon
export const CheckIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
      />
    </svg>
  </Icon>
);

// Filter Icon
export const FilterIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
      />
    </svg>
  </Icon>
);

// Download Icon
export const DownloadIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
    </svg>
  </Icon>
);

// Upload Icon
export const UploadIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
    </svg>
  </Icon>
);

// Menu/Hamburger Icon
export const MenuIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
      />
    </svg>
  </Icon>
);

// Orders/Cart Icon
export const OrdersIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
      />
    </svg>
  </Icon>
);

// Calendar Icon
export const CalendarIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM9 10H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z"
      />
    </svg>
  </Icon>
);

// Location Icon
export const LocationIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      />
    </svg>
  </Icon>
);

// Email Icon
export const EmailIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
      />
    </svg>
  </Icon>
);

// Phone Icon
export const PhoneIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
      />
    </svg>
  </Icon>
);

// More/Dots Icon
export const MoreIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      />
    </svg>
  </Icon>
);

// Logo Icon (MallBuddy)
export const LogoIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 40 40">
      <circle cx="20" cy="20" r="18" fill="#FF5309" />
      <path
        fill="white"
        d="M12 28V14h3.5l3 9 3-9H25v14h-2.5v-9.5l-3 9.5h-2l-3-9.5V28H12z"
      />
    </svg>
  </Icon>
);

// Arrow Up Icon
export const ArrowUpIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M7 14l5-5 5 5z" />
    </svg>
  </Icon>
);

// Arrow Down Icon
export const ArrowDownIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M7 10l5 5 5-5z" />
    </svg>
  </Icon>
);

// Refresh Icon
export const RefreshIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
      />
    </svg>
  </Icon>
);

// Image Icon
export const ImageIcon = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
      />
    </svg>
  </Icon>
);

export default {
  DashboardIcon,
  MallIcon,
  RestaurantIcon,
  UsersIcon,
  PromoIcon,
  SettingsIcon,
  SearchIcon,
  NotificationIcon,
  LogoutIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
  PlusIcon,
  EditIcon,
  DeleteIcon,
  ViewIcon,
  CloseIcon,
  CheckIcon,
  FilterIcon,
  DownloadIcon,
  UploadIcon,
  MenuIcon,
  OrdersIcon,
  CalendarIcon,
  LocationIcon,
  EmailIcon,
  PhoneIcon,
  MoreIcon,
  LogoIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  RefreshIcon,
  ImageIcon,
};
